/*
  Attar de Astana · collection page

  One behaviour: the sort select submits its own form when it changes. Without scripts the
  form has a visible Apply button instead.
*/

(() => {
  const wire = (root) => {
    root.querySelectorAll('[data-col-sort] select').forEach((select) => {
      if (select.dataset.wired) return;
      select.dataset.wired = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
  };
  wire(document);
  document.addEventListener('shopify:section:load', (event) => wire(event.target));
})();
